import React, { Component } from "react"
import PropTypes from "prop-types"
import Uploader from "app/attachments/uploader"
import Icon from "@kit/design/icon"
import "./uploader-button.css"

export default class UploaderButton extends Component {
  static propTypes = {
    adapter: PropTypes.func,
    onProgress: PropTypes.func,
    onComplete: PropTypes.func,
    labelText: PropTypes.string,
    id: PropTypes.string,
    icon: PropTypes.string
  }

  render() {
    const {
      id,
      labelText,
      adapter,
      icon,
      onProgress,
      onComplete,
      ...buttonProps
    } = this.props

    return (
      <Uploader
        adapter={adapter}
        onComplete={onComplete}
        onProgress={onProgress}
        render={({ handleUpload, upload }) => (
          <div className="uploader-button">
            <input id={id} type="file" onChange={handleUpload} />
            <label
              htmlFor={id}
              {...buttonProps}
              className="text-sm font-semibold bg-gray-200 rounded-sm h-10 px-4 m-0 cursor-pointer hover:bg-gray-300"
            >
              <span
                className="flex items-center h-full w-full truncate"
                style={{ maxWidth: "165px" }}
              >
                {icon && <Icon name={icon} className="mr-2" />}
                {upload && !upload.complete ? upload.file_name : labelText}
              </span>
            </label>

            {upload && !upload.complete && (
              <div
                style={{
                  width: ((upload.loaded || 0) / upload.size) * 100 + "%"
                }}
                className="uploader-button--progress"
              />
            )}
          </div>
        )}
      />
    )
  }
}
